import { render, staticRenderFns } from "./BoardCardsAccounting.vue?vue&type=template&id=cdc0e97c&"
import script from "./BoardCardsAccounting.vue?vue&type=script&lang=js&"
export * from "./BoardCardsAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports